<template>
  <div class="richieste-di-offerta">
    <div class="row row-custom">
      <div class="titolo-app col-lg-20 col-md-19 col-sm-17 col-1 no-padding">
        <span class="titolo-bold d-none d-sm-block">
          {{ $t('richiesteDiOfferta.richiesteDiOfferta').toUpperCase() }}
        </span>
      </div>
      <div class="icone col-lg-4 col-md-5 col-sm-7 col-23 no-padding" v-show="showIndietro">
        <div class="icona" @click="indietro">
          <div class="icona-menu">
            <icon name="riv-lista" flip="horizontal" scale="1.5"></icon>
          </div>
          <div class="label-menu no-padding">
            <span v-html="$t('richiesteDiOfferta.listaOfferte')"></span>
          </div>
        </div>
      </div>
    </div>
    <div id="contenitore" class="contenitore col-24 no-padding"
         :style="{ height: contenitoreHeight + 'px', overflowY: (showScroll) ? 'auto' : 'hidden' }">
      <keep-alive>
        <router-view @hideScroll="hideScroll" @showScroll="showScroll = true"></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'RichiesteDiOfferta',
    props: {
      contenitoreHeight: {
        type: Number,
        required: true,
        default: 550
      }
    },
    i18n: {
      messages: {
        it_IT: {
          richiesteDiOfferta: {
            listaOfferte: 'Lista<br>Offerte',
            richiesteDiOfferta: 'Richieste di Offerta'
          }
        },
        fr_FR: {
          richiesteDiOfferta: {
            listaOfferte: 'Liste<br>Offres',
            richiesteDiOfferta: 'Demandes d\'Offre'
          }
        },
        es_ES: {
          richiesteDiOfferta: {
            listaOfferte: 'Lista<br>Ofertas',
            richiesteDiOfferta: 'Peticiones de Oferta (Recambios)'
          }
        },
        de_DE: {
          richiesteDiOfferta: {
            listaOfferte: 'Liste<br>Angebote',
            richiesteDiOfferta: 'Angebotsanfragen'
          }
        },
        en_GB: {
          richiesteDiOfferta: {
            listaOfferte: 'List<br>Offers',
            richiesteDiOfferta: 'Offer requests'
          }
        }
      }
    },
    data () {
      return {
        showScroll: true
      }
    },
    methods: {
      hideScroll: function () {
        var container = this.$el.querySelector('#contenitore')
        container.scrollTop = 0
        this.$set(this, 'showScroll', false)
      },
      indietro: function () {
        this.$router.push({name: 'RdOOfferte'})
      }
    },
    computed: {
      showIndietro: function () {
        let path = this.$route.path
        return (path.indexOf('/fornitura/richiestediofferta/dettaglio') >= 0)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";

  .richieste-di-offerta {
    .titolo-app {
      padding-left: 5px;
      .set-font(@size: 15px, @color: @greenRiva);
      letter-spacing: 2px;
      overflow: hidden;
      height: 50px;
      line-height: 50px;
      .titolo-bold {
        font-weight: 700;
      }
    }
    .icone {
      padding-top: 10px;
      padding-bottom: 10px;
      text-align: right;
      .icona:hover {
        cursor: pointer;
      }
      .icona {
        text-align: center;
        width: 170px;
        display: inline-block;
      }
      .icona-menu {
        padding-left: 0px;
        padding-right: 3px;
        // padding-top: 3px;
        text-align: right;
        display: inline-block;
        vertical-align: middle;
      }
      .label-menu {
        .set-font(@size: 13px, @family: 'os-semibold');
        text-align: center;
        display: inline-block;
        vertical-align: middle;
        line-height: 17px;
        // margin-top: -4px;
      }
    }
    .contenitore {
      -webkit-box-shadow: 0 0 10px 2px #cecece;
      -moz-box-shadow: 0 0 10px 2px #cecece;
      box-shadow: 0 0 10px 2px #cecece;
      background-color: #ffffff;
      margin: auto;
      overflow-x: hidden;
      border-radius: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Fornitura/RichiesteDiOfferta/RichiesteDiOfferta.vue